export default async function GetMyPlansApi(
  performanceCycle,
  planLevelled,
  page,
  LIMIT_PER_PAGE,
  POSITION_ID
) {
  let res = "";
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/plans/my-plans?performanceCycleId=${performanceCycle}&planLevelId=${planLevelled}&page=${page}&limit=${LIMIT_PER_PAGE}&positionId=${POSITION_ID}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
